import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import LogoIcon from './logo.svg';

import style from './Logo.scss';

const cn = bemCssModules(style, 'Logo');
const ti = getTestId('Logo');

export type TLogo = {
  className?: string;
  mixBlendMode?: boolean;
} & React.HTMLAttributes<HTMLOrSVGElement>;

export const Logo: React.FC<TLogo> = props => {
  const { className, mixBlendMode, ...rest } = props;

  return <LogoIcon className={cn({ mixBlendMode }, [className])} data-testid={ti()} {...rest} />;
};

export default Logo;
